import { firestore, firebaseApp } from '../main';

export default {
  namespaced: true,
  state: {
    selectedCountry: null,
    countries: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null
  },
  mutations: {
    RECEIVED_COUNTRIES(state, payload) {
      state.countries = payload;
      // if(state.selectedCountry == null){
      //   state.selectedCountry = state.countries[0];
      // }
      state.isReceiving = false;
    },
    RECEIVING_COUNTRIES(state) {
      state.isReceiving = true;
    },
    UPDATED_COUNTRY(state, payload) {
      let index = state.countries.findIndex(p => p.id === payload.id);
      if (index == -1) {
        state.countries = [...state.countries, payload];
      }
      state = Object.assign(state, {
        countries: state.countries.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_COUNTRY(state) {
      state.isUpdating = true;
    },
    DELETED_COUNTRY(state, payload) {
      let indexToDelete = state.countries.findIndex(p => p.id === payload.id);
      let countries = [...state.countries];
      countries.splice(indexToDelete, 1);
      state = Object.assign(state, {
        countries: [...countries],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_COUNTRY(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
    SELECT_COUNTRY(state, payload) {
      state.selectedCountry = payload;
    },
    INITIALIZE_SELECTED_COUNTRY(state, payload) {
      state.selectedCountry = state.countries.filter(c => c.id === payload)[0];
    }
  },
  actions: {
    async selectCountry({ commit }, payload) {
      commit('SELECT_COUNTRY', payload.country);
      const userId = payload.userId;
      const countryId = payload.country.id;
      await firestore
        .collection('users')
        .doc(userId)
        .set({ selectedCountryId: countryId }, { merge: true });
    },
    async initializeSelectedCountry({ commit }, payload) {
      const user = payload.user;
      const countries = payload.countries;
      let selectedCountryId = null;
      if (user.selectedCountryId == null) {
        const selectedCountry = countries[0];
        selectedCountryId = selectedCountry.id;
        await firestore
          .collection('users')
          .doc(user.id)
          .set({ selectedCountryId: selectedCountryId }, { merge: true });
      } else {
        selectedCountryId = user.selectedCountryId;
      }
      commit('INITIALIZE_SELECTED_COUNTRY', selectedCountryId);
    },
    async getCountriesRequest({ dispatch }) {
      dispatch('receivingCountries');
      const snapshot = await firestore.collection('countries').get();
      const countries = snapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
      dispatch('receiveCountries', countries);
    },
    async updateCountryRequest({ dispatch }, payload) {
      dispatch('updatingCountry');

      await firestore
        .collection('countries')
        .doc(payload.id)
        .set(payload.country, { merge: true });
      payload.$toasted.success(payload.successMessage ? payload.successMessage : 'Country has been updated!');
      dispatch('updateCountry', payload.country);
    },

    async createCountryRequest({ dispatch }, payload) {
      dispatch('updatingCountry');
      const countryRef = await firestore.collection('countries').add(payload.country);
      const countrySnapshot = await firestore
        .collection('countries')
        .doc(countryRef.id)
        .get();
      payload.$toasted.success('Country has been created!');
      dispatch('updateCountry', Object.assign({}, countrySnapshot.data(), { id: countryRef.id }));
    },
    async deleteCountryRequest({ dispatch }, payload) {
      dispatch('deletingCountry', payload);
    },
    receiveCountries({ commit }, payload) {
      commit('RECEIVED_COUNTRIES', payload);
    },
    receivingCountries({ commit }) {
      commit('RECEIVING_COUNTRIES');
    },
    updateCountry({ commit }, payload) {
      commit('UPDATED_COUNTRY', payload);
    },
    updatingCountry({ commit }) {
      commit('UPDATING_COUNTRY');
    },
    deleteCountry({ commit }, payload) {
      commit('DELETED_COUNTRY', payload);
    },
    deletingCountry({ commit }, payload) {
      commit('DELETING_COUNTRY', payload);
    }
  }
};
